<div class="card">
  <!-- Card header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <!-- Search -->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadCurrencyRates(1, searchTerm, filters)"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search currency rates">
      </div>
    </div>

    <!-- Card toolbar -->
    <div class="card-toolbar">
      <div class="d-flex justify-content-end gap-2" data-kt-currency-rate-table-toolbar="base">
        <!-- Filter button -->
        <button
          type="button"
          class="btn btn-light-primary"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>
      </div>
    </div>
  </div>

  <!-- Card body -->
  <div class="card-body py-4">
    <!-- Filters Form -->
    <div *ngIf="showFiltersForm" [@slideInOut] class="mb-5">
      <div class="card card-flush shadow-sm">
        <div class="card-header">
          <h3 class="card-title">Filters</h3>
        </div>
        <div class="card-body">
          <div class="row g-5">
            <!-- Add filter fields here if needed -->
            <div class="col-12">
              <p class="text-muted">No additional filters available</p>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light" (click)="resetFilters()">Reset</button>
          <button type="button" class="btn btn-primary" (click)="applyFilters()">Apply Filters</button>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_currency_rates_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="min-w-100px">Date</th>
            <th class="min-w-250px text-center" colspan="3">USD</th>
            <th class="min-w-250px text-center" colspan="3">EUR</th>
            <th class="min-w-250px text-center" colspan="3">GBP</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th></th>
            <!-- USD sub-columns -->
            <th class="min-w-80px text-center">TTB</th>
            <th class="min-w-80px text-center">TTM</th>
            <th class="min-w-80px text-center">TTH</th>
            <!-- EUR sub-columns -->
            <th class="min-w-80px text-center">TTB</th>
            <th class="min-w-80px text-center">TTM</th>
            <th class="min-w-80px text-center">TTH</th>
            <!-- GBP sub-columns -->
            <th class="min-w-80px text-center">TTB</th>
            <th class="min-w-80px text-center">TTM</th>
            <th class="min-w-80px text-center">TTH</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let rate of currencyRates; trackBy: trackByFn">
            <td>
              <span class="text-dark fw-bold">{{ rate.date || 'N/A' }}</span>
            </td>
            <!-- USD columns -->
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTB(rate.usd) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800 fw-bold">{{ calculateTTM(rate.usd) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTH(rate.usd) | number:'1.2-2' }}</span>
            </td>
            <!-- EUR columns -->
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTB(rate.eur) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800 fw-bold">{{ calculateTTM(rate.eur) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTH(rate.eur) | number:'1.2-2' }}</span>
            </td>
            <!-- GBP columns -->
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTB(rate.gbp) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800 fw-bold">{{ calculateTTM(rate.gbp) | number:'1.2-2' }}</span>
            </td>
            <td class="text-center">
              <span class="text-gray-800">{{ calculateTTH(rate.gbp) | number:'1.2-2' }}</span>
            </td>
            <!-- Actions -->
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(rate)"
                  title="Edit Currency Rate">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="currencyRates.length === 0">
            <td colspan="11" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No currency rates found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && currencyRates.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Edit Currency Rate Modal -->
<app-edit-currency-rate
  (currencyRateUpdated)="onCurrencyRateUpdated()">
</app-edit-currency-rate>
